import { Rule } from "antd/lib/form";

type ValidationType = "email" | "url" | "username" | "slug";

/**
 * Get an Antd's validation rule object for given field type.
 */
export const getValidationRule = (type: ValidationType): Rule => {
  switch (type) {
    case "url":
      return {
        transform(value) {
          return value?.trim();
        },
        type: "url",
      };
    case "email":
      return {
        transform(value) {
          return value?.trim();
        },
        type: "email",
      };
    case "username":
      return {
        transform(value) {
          return value?.trim();
        },
        pattern: /^[a-zA-Z0-9_.]+$/,
      };
  }
};
